import {Page} from '@daedalus/core/src/analytics/types/Events'
// eslint-disable-next-line
import {brands} from '@daedalus/core/src/brand/config'
import {BrandCode} from '@daedalus/core/src/brand/types'

const canonicalUrlsMapProduction: Partial<
  Record<BrandCode, Partial<Record<Page, string>>>
> = {
  vio: {
    [Page.Home]: brands.vio.siteAddresses.address
  }
}

const canonicalUrlsMapStaging: Partial<
  Record<BrandCode, Partial<Record<Page, string>>>
> = {
  vio: {
    [Page.Home]: brands.vio.environmentAddresses?.stagingAddress
  }
}

export const getCanonicalUrl = (brandCode: BrandCode, page?: Page) => {
  if (!page) {
    return undefined
  }

  const canonicalUrlsMap =
    process.env.NEXT_PUBLIC_ENV === 'prd'
      ? canonicalUrlsMapProduction
      : canonicalUrlsMapStaging
  const canonicalUrl = canonicalUrlsMap[brandCode]?.[page]

  return canonicalUrl
}
